<!-- //
颜色选择器
@auth xuyd
@date 2024-05-04
//-->
<template>
  <el-input v-model="inputValue" style="width: 100%" placeholder="请输入颜色" maxlength="30">
    <el-color-picker size="mini"
                     slot="append"
                     v-model="inputValue"
                     show-alpha
                     :predefine="predefineColors"
                     />
  </el-input>
</template>

<script>

const predefineColors = [
  "#1d202d",
  "#263445",
  "#a8e3ff",
  "#ff4500",
  "#ff8c00",
  "#ffd700",
  "#90ee90",
  "#00ced1",
  "#1e90ff",
  "#c71585"
];

export default {
  name: 'ColorSelector',
  data() {
    return {
      inputValue: this.colorValue,
      predefineColors: predefineColors
    }
  },
  model: {
    prop: "colorValue",
    event: "input"
  },
  props: {
    colorValue: {
      type: String,
      default: ''
    }
  },
  watch: {
    colorValue(val) {
      this.inputValue = val;
    },
    inputValue(val) {
      this.$emit('input', val);
    },
  }
}
</script>

<style lang="less" scoped>
:deep(.el-color-picker--mini),
:deep(.el-color-picker--mini .el-color-picker__trigger) {
  width: 24px;
  height: 24px;
}
</style>

